import React from 'react';

const PlusIcon = props => {
    return (
        <svg width='34' height='34' viewBox='0 0 34 34' {...props}>
            <g fill='none' fillRule='nonzero'>
                <path fill='#1D1D1B' d='M17 28c6.075 0 11-4.925 11-11S23.075 6 17 6 6 10.925 6 17s4.925 11 11 11z' />
                <path
                    fill='#FFF'
                    d='M17.821 17.94l-.021 3.849-1.714.01.021-3.85-3.849.021.01-1.714 3.848-.022.022-3.973 1.715-.01-.022 3.974 3.973-.022-.01 1.714z'
                />
            </g>
        </svg>
    );
};

export default PlusIcon;
